import validator from "validator";
import { CreateLocationPayload } from "../../types/location/location-payload";

export const validateLocationPayload = (
  createLocationPayload: CreateLocationPayload
) => {
  const address = validator.isEmpty(createLocationPayload.address);
  // const longitude =
  //   validator.isEmpty(String(createLocationPayload.longitude)) ||
  //   createLocationPayload.longitude < 125 ||
  //   createLocationPayload.longitude > 130;
  // const latitude =
  //   validator.isEmpty(String(createLocationPayload.latitude)) ||
  //   createLocationPayload.latitude < 30 ||
  //   createLocationPayload.latitude > 40;

  return {
    hasError: address,
    // || longitude || latitude,
    validationResults: {
      address,
      // longitude,
      // latitude,
    },
  };
};
